import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
// import TagManager from './TagManager';

class TagStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return [];
  }

  reduce(state, action) {
    switch (action.actionType) {
      // case ActionTypes.GET_ALL_TAGS:
        // TagManager.getAllTags();
        // return state;

      // case ActionTypes.GET_ALL_TAGS_COMPLETED:
      //   return action.tags;

      case ActionTypes.GLOSSARY_GET_ALL_TERMS_COMPLETED:
        return action.glossary.reduce((carry, term) => {
          return carry.concat(
            term.tags.filter(tag => ! carry.some(_tag => _tag.id === tag.id))
          );
        }, []).sort((tag1, tag2) => tag1.name.localeCompare(tag2.name));

      default:
        return state;
    }
  }
}

export default new TagStore();
